define('modules/duplicate_control/view',['require','exports','module','base/view','jquery','ldsh!./template'],function(require, exports, module){
  "use strict";

  var BaseView = require("base/view"),
    $ = require("jquery");

  module.exports = BaseView.extend({
    template: require("ldsh!./template"),
    events: {
      "change #on_duplicated_key": "updateOnDuplicatedKey",
      "keyup #error_message_for_duplicate_control": "updateErrorMessage"
    },
    updateOnDuplicatedKey: function(e) {
      var selectedValue = $(e.currentTarget).find("option:selected").attr("value");
      this.model.set('on_duplicated_key', selectedValue);
      this.render();
    },
    updateErrorMessage: function(e) {
      this.model.set('error_message', $(e.currentTarget).val());
    },
    onRender: function(){
      this.$el.i18n();
    }
  });

});

